const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkeringBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "parkering",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286.69 172.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "af42564d-b9da-4119-91e5-4a35c6454c88",
    "data-name": "border",
    d: "M44.2,39l.45-32L149.59,6.7s1,20.09,1,20.6c.36,4.92,9.4,9.42,13.16,3.06,2.91-4.92,4-30.11,4-30.11l45.74.06s-.94,24,0,31.91,12.18-2.59,19.19,1.22,31.53,18.32,35.64,24.17-2.89,8.46-4.38,10.24,17.54,19.88,20.53,25.22c5.32,9.47-2,10.21-2.6,14.17s6.09,38.9-2.05,41.33-11.65-6.08-13.74-8.82-33.22-1.32-39.42-1.85-13.28,6.92-15.24,8.8c-5.61,5.38-23.87,4.86-31.16,2.58s-3.42-5.4-6-7.84-36.4-2.61-43-1.09-8.89,18-10.06,22.07-5.53,7.77-12.59,9.29-21.86-1.52-24.52-5-2.21-14.45-5.76-18.89-43.34-1-48.66-1.09-17.51,2.48-22.38,0S6.08,113,6.38,108.76,3,105.34.6,98.56s8.52-9,11.92-9.8,5.13-8.69,6.91-11.67S25,65.16,28.3,60.28s8.53-9.74,10.85-13.35Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkeringBorder);
export default __webpack_public_path__ + "static/media/parkering-border.a9fd57db551bc067e1e3504354768b32.svg";
export { ForwardRef as ReactComponent };